import { useState } from "react";
import { Dropdown, Menu, message, Row, TableColumnsType } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";

import Table from "@components/Table";
import Button from "@components/Button";
import {
  ErrorServices,
  useDeleteCompanySubJobFunctionMutation,
  useFetchCompanyJobFunctionByIdQuery,
  useFetchPaginatedCompanySubJobFunctionsQuery,
} from "@services";

import AddCompanyJobSubFunction from "./AddJobSubFunction";
import EditCompanyJobSubFunction from "./EditJobSubFunction";

import { ReactComponent as MenuIcon } from "@assets/images/vertical-dots.svg";
import { useTypedSelector } from "@/hooks";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";

type SubJobFunctionType = {
  id: number;
  name: string;
  description?: string | null;
};

const CompanySubJobFunction = () => {
  const { job_id: company_job_function_id, company_id } =
    useParams<{ job_id: string; company_id: string }>();
  const [isAddJSFVisible, setIsAddJSFVisible] = useState(false);
  const [isEditJSFVisible, setIsEditJSFVisible] = useState(false);
  const [jsfItem, setJsfItem] = useState<SubJobFunctionType | {}>({});

  const [deleteSubJobFunction] = useDeleteCompanySubJobFunctionMutation();
  const history = useHistory();
  const { user, permissions: per } = useTypedSelector(state => state.auth);

  const { data, isLoading: isLoadingSubJobFunctions } =
    useFetchCompanyJobFunctionByIdQuery({
      company_id: company_id,
      company_job_function_id,
    });

  const jobFunction = data?.data;
  const subJobFunctions = jobFunction?.sub_job_functions || [];

  const handleActionDropdown = ({
    item,
    key,
    domEvent,
  }: {
    key: string;
    domEvent:
      | React.MouseEvent<HTMLElement, MouseEvent>
      | React.KeyboardEvent<HTMLElement>;
    item: SubJobFunctionType;
  }) => {
    domEvent.stopPropagation();

    if (key === "2") {
      removeSubJobFunction(item?.id.toString());
    } else {
      onEditJSf(item);
    }
  };

  const columns: TableColumnsType<SubJobFunctionType> = [
    {
      title: "Company Job Sub-Functions",
      key: "name",
      dataIndex: "name",
      width: "80%",
    },
    ...((checkPermission(permissions.UPDATE_COMPANY_SUB_JOB_FUNCTION) ||
    checkPermission(permissions.DELETE_COMPANY_SUB_JOB_FUNCTION)
      ? [
          {
            title: "Actions",
            key: "action",
            width: 160,
            align: "center",
            render: (item: SubJobFunctionType) => (
              <div className="flex items-center gap-2">
                {checkPermission(
                  permissions.UPDATE_COMPANY_SUB_JOB_FUNCTION
                ) && (
                  <div
                    onClick={e => {
                      e.stopPropagation();
                      handleActionDropdown({
                        item,
                        key: "1",
                        domEvent: e,
                      });
                    }}
                    className="table__action__btn table__action__btn--client"
                  >
                    Edit
                  </div>
                )}

                {checkPermission(
                  permissions.DELETE_COMPANY_SUB_JOB_FUNCTION
                ) && (
                  <div
                    onClick={e => {
                      e.stopPropagation();
                      handleActionDropdown({
                        item,
                        key: "2",
                        domEvent: e,
                      });
                    }}
                    className="table__action__btn table__action__btn--delete"
                  >
                    Delete
                  </div>
                )}
              </div>
            ),
          },
        ]
      : []) as any),
  ];

  const onEditJSf = async (item: SubJobFunctionType) => {
    try {
      setJsfItem(item);
      setIsEditJSFVisible(true);
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const removeSubJobFunction = async (id: string) => {
    try {
      await deleteSubJobFunction({
        company_id: company_id,
        company_sub_job_function_id: id,
      }).unwrap();

      message.success("Company Sub Job Function Deleted Successfully");
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  return (
    <>
      <AddCompanyJobSubFunction
        setIsVisible={setIsAddJSFVisible}
        isVisible={isAddJSFVisible}
        company_job_function_id={company_job_function_id}
        companyId={company_id}
      />

      <EditCompanyJobSubFunction
        setIsVisible={setIsEditJSFVisible}
        isVisible={isEditJSFVisible}
        jsfItem={jsfItem}
        companyId={company_id}
      />

      <div className="appTitle text-base font-[500] mx-5">
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(`/company-job-functions/company/${company_id}`)
          }
        >
          Company Job Functions
        </span>
        {" > "}
        Company Sub Functions
      </div>

      <div className="bg-white p-4 sm:p-5">
        <div className="jobCreationBar sticky top-0 z-10 bg-themeCore px-14 py-6 rounded-lg flex justify-between items-center my-7">
          <div className="title text-white font-[500] text-3xl uppercase">
            Company Job Sub Functions
          </div>

          {(per?.includes("CREATE_JOB_SUB_FUNCTION") ||
            per?.includes("all")) && (
            <Button
              variant="buttonWhite"
              onClick={() => setIsAddJSFVisible(true)}
            >
              Add Job-Sub Function
            </Button>
          )}
        </div>

        <Row>
          <Table
            data={subJobFunctions}
            columns={columns}
            isLoading={isLoadingSubJobFunctions}
          />
        </Row>
      </div>
    </>
  );
};

export default CompanySubJobFunction;
